<template>
  <div id="demo-basic-card">

    <vs-alert color="danger" title="Requested Module Not Found" :active.sync="module_not_found">
        <span>Module record with id: {{ $route.params.moduleId }} not found. </span>
        <span>
            <span>Check </span><router-link :to="{name:'modules'}" class="text-inherit underline">All Modules</router-link>
        </span>
    </vs-alert>

    <div id="module-data" v-if="module_data">
        <div id="editModuleLoadingDiv" class="vs-con-loading__container">
            <vx-card :title="moduleName" class="mb-base">
                <template   slot="actions">
                    <vx-tooltip text="Back to all modules" position="left">
                        <feather-icon @click="redirectToAllModule()" icon="ChevronsLeftIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                    </vx-tooltip>
                </template>
                <vs-tabs>
                    <vs-tab label="Module">
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2 w-full mb-2">
                                <vs-input v-validate="'required'" name="name" ref="name" class="w-full" label="Module name" v-model="module_data.name" />
                                <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                            </div>
                            <div class="vx-col sm:w-1/2 w-full mb-2">
                                Type
                                <v-select v-validate="'required'" name="type" ref="type" v-model="moduleType" :options="['Teori','Kørsel','Manøvre','Glatbane','Other']" />
                                <span class="text-danger text-sm" v-show="errors.has('type')">{{ errors.first('type') }}</span>
                            </div>
                        </div>
                        <div class="vx-row" v-if="moduleType == 'Other'">
                            <div class="vx-col  w-full mb-4">
                                <vs-input v-validate="'required'" name="other_type" ref="other_type" class="w-full" label="Add module type" v-model="otherModuleType" />
                                <span class="text-danger text-sm" v-show="errors.has('other_type')">{{ errors.first('other_type') }}</span>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2 w-full mb-4">
                                <vs-input class="w-full" label="Class Location" v-model="module_data.location" />
                            </div>
                            <div class="vx-col sm:w-1/2 w-full mb-4">
                                Duration (Minutes)
                                <v-select label="Name" v-model="module_data.hours" :options="[45, 90, 135, 180, 225, 270, 315, 360]" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col  w-full mb-4">
                                Tags
                                <treeselect v-model="tag_values" :multiple="true" :options="tags" />
                                
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col  w-full mb-2">
                                Description
                                <vs-textarea  v-model="module_data.description" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col  w-full mb-2">
                                Sms alert content
                                <vs-textarea  v-model="module_data.sms_content" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col  w-full mb-2">
                                Email alert content
                                <vs-textarea  v-model="module_data.email_content" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col  w-full mb-4">
                                Lession number
                                <v-select v-validate="{regex: '^([0-9]+)$' }" name="lession_number" ref="lession_number"   taggable push-tags multiple :closeOnSelect="false" v-model="module_data.lession_number" :options="[]"/>
                                <span class="text-danger text-sm" v-show="errors.has('lession_number')">{{ errors.first('lession_number') }}</span>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col w-full mb-6">
                                <vs-checkbox class="inline-flex" v-model="moduleTypeLimited">Tick if you need unlimited number of booking</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col w-full"  align="right">
                              <vs-button @click="validateBookingForm()" class="mr-3 mb-2">Save Changes</vs-button>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Feedback" v-if="moduleType != 'Teori'">
                        <div class="vx-row mt-2 mx-1" v-for="(bookingFeedback, index) in feedbacks" :key="index" v-if="feedbacks.length">
                            <div class="vx-col sm:w-full w-full mb-5">
                                <vx-input-group class="" >
                                    <template slot="append" >
                                        <div class="append-text pr-0" style="background-color: #e7e7e7;">
                                            <vs-switch @change.prevent="updateFeedback(index)" color="primary" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="bookingFeedback.answer_type_bool">
                                                <span slot="on">Text</span>
                                                <span slot="off">Emoji</span>
                                            </vs-switch>
                                            <vs-button @click="removeField(index)" class="ml-2" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
                                        </div>
                          
                                    </template>
                                    <vs-input v-validate="'required'" :name="'feedback_question_'+index" :ref="'feedback_question_'+index" v-model="bookingFeedback.question" />
                                </vx-input-group>
                                <span class="text-danger text-sm" v-show="errors.has('feedback_question_'+index)">This field is required</span>
                            </div>
                        </div>

                        <!-- Save & Reset Button -->
                        <div class="flex flex-wrap items-center justify-end vx-row mt-2 mx-4">
                            <div class="vx-col sm:w-full w-full flex flex-wrap items-center justify-end">
                                <vs-button @click="addNewField()" class="ml-4 mt-2" >Add field</vs-button>
                                <vs-button @click="validateData()" class="ml-4 mt-2">Save Changes</vs-button>
                            </div>
                        </div>
                    </vs-tab>
                </vs-tabs>
            </vx-card>
        </div>
    </div>
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleModuleManagement from '@/store/module-management/moduleModuleManagement.js'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moduleClubManagement from '@/store/club-management/moduleClubManagement.js'

export default{
    data() {
        return {
            module_data: null,
            module_not_found: false,
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            tags : [],
            tag_values : [],
            tagId:{
                parent:[],
                child:[],
                childOfChild:[],
            },
            otherModuleType_ : null,
            moduleName : null,
            feedbacks : [],
        }
    },
    components: {
        VuePerfectScrollbar,
        swiper,
        swiperSlide,
        vSelect,
        Treeselect,
    },
    computed: {
        moduleType: {
            set: function(val) {
                this.module_data.type = val.toLowerCase();
            },
            get: function() {
                let type = this.module_data.type
                return type[0].toUpperCase() + type.slice(1);
            }
        },
        otherModuleType: {
            set: function(val) {
                this.otherModuleType_ = val
            },
            get: function() {
                return this.module_data.other_type;
            }
        },
        moduleTypeLimited: {
            set: function(val) {
                this.module_data.booking_status = (val) ? 'unlimited' : 'limited';
            },
            get: function() {
                return (this.module_data.booking_status == 'unlimited') ? true : false;
            }
        },
    },
    methods: {
        updateFeedback(index) {
            this.$forceUpdate();
        },
        removeField(index) {
            this.feedbacks.splice(index, 1);
        },
        addNewField() {
          this.feedbacks.push({ question : "", answer_type : "text", answer_type_bool : false, feedback_type : "student_bookings"})
        },
        validateData() {
          this.$validator.validateAll().then(result => {
            if (result && this.feedbacks.length) this.updateFeedbackData()
          })
        },
        updateFeedbackData() {
          var self = this
          
          this.$vs.loading({
            container: '#editModuleLoadingDiv',
            scale: 0.6
          })

          let feedbackData = [];

          for(var i = 0; this.feedbacks.length > i; i++){
            feedbackData.push({
                answer_type : this.feedbacks[i].answer_type_bool == true ? "text" : "emoji",
                feedback_type : "student_bookings",
                question : this.feedbacks[i].question
            })
          }

          let data = {
            feedbacks : feedbackData,
            module_id : this.module_data.id,
        }

          this.$store.dispatch("clubManagement/manageFeedback", data)
            .then(res => { 
                this.$vs.loading.close('#editModuleLoadingDiv > .con-vs-loading')

                this.$vs.notify({
                    title: "Success.",
                    text: "Feedback updated successfully.",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success"
                });
            })
            .catch(err => { 
              if(err.status && err.status == 422){
                Object.keys(err.data).forEach(function(key) {
                  self.errors.add({
                    field: key,
                    msg: err.data[key][0],
                  });
                });
              }

              this.$vs.loading.close('#editModuleLoadingDiv > .con-vs-loading')
            })

        },
        // getFeedbackData() {
        //   this.$store.dispatch("clubManagement/getFeedbackData")
        //     .then(res => { 
        //         for(var i = 0; res.data.length > i; i++){
        //             res.data[i].answer_type_bool = res.data[i].answer_type == "text" ? true : false
        //           }

        //       this.feedbacks = res.data
        //     })
        //     .catch(err => { })
        // },
        redirectToAllModule() {
            this.$router.push("/modules").catch(() => {})
        },
        validateBookingForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.updateModule()
                else{

                }
            })
        },
        storeTagId(Tags){
            let parent = []
            let child = []
            let childOfChild = []

            Tags.forEach(function(element,index){
              parent.push(element.id)

              if(Tags[index].children){
                let children = Tags[index].children

                children.forEach(function(elementC,indexC){
                  child.push(children[indexC].id)

                  if(Tags[index].children[indexC].children){
                    let childrenOfChild=Tags[index].children[indexC].children
                    childrenOfChild.forEach(function(elementCC,indexCC){
                      childOfChild.push(childrenOfChild[indexCC].id)
                    })
                  }
                })
              }
            })

            this.tagId.parent = parent
            this.tagId.child = child
            this.tagId.childOfChild = childOfChild
        },
        tagIdAnalyze(tagIdList){
            console.log(tagIdList)

            let oldParent = this.tagId.parent
            let oldChild = this.tagId.child
            let oldchildOfChild = this.tagId.childOfChild

            let finalParent = []
            let finalChild = []
            let finalChildOfChild = []


            tagIdList.forEach(function(element,index){
              oldParent.forEach(function(elementP,indexP){
                if(elementP == element){
                  finalParent.push(elementP)
                }
              })
              oldChild.forEach(function(elementC,indexC){
                if(elementC == element){
                  finalChild.push(elementC)
                }
              })
              oldchildOfChild.forEach(function(elementCC,indexCC){
                if(elementCC == element){
                  finalChildOfChild.push(elementCC)
                }
              })
            })

            return {
              finalParent,
              finalChild,
              finalChildOfChild
            };
        },
        updateModule() {
            this.$vs.loading({
                container: '#editModuleLoadingDiv',
                scale: 0.6
            })

            let moduleData = this.module_data
            moduleData.other_type = this.otherModuleType_

            var {finalParent,finalChild,finalChildOfChild} = this.tagIdAnalyze(this.tag_values)

            moduleData.tags = this.tag_values
            moduleData.parent = finalParent
            moduleData.child = finalChild
            moduleData.sub_child = finalChildOfChild

            this.$store.dispatch("moduleManagement/updateModule", moduleData)
            .then(res => { 
                this.$vs.loading.close('#editModuleLoadingDiv > .con-vs-loading')

                this.$vs.notify({
                  time:4000,
                  title:'Success',
                  text: (res.data.status) ? res.data.status : 'Sussfully Updated.',
                  color:'success',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'
                });
            })
            .catch(err => {
                this.$vs.loading.close('#editModuleLoadingDiv > .con-vs-loading')
            })
        },
    },
    created() {
        if(!moduleModuleManagement.isRegistered) {
            this.$store.registerModule('moduleManagement', moduleModuleManagement)
            moduleModuleManagement.isRegistered = true
        }

        const moduleId = this.$route.params.moduleId
        this.$store.dispatch("moduleManagement/getAModule", moduleId)
            .then(res => { 
                this.module_data = res.data 
                this.moduleName = res.data.name
                if(res.data.teacher_feedbacks && res.data.teacher_feedbacks.length){
                    for(var i = 0; res.data.teacher_feedbacks.length > i; i++){
                        res.data.teacher_feedbacks[i].answer_type_bool = res.data.teacher_feedbacks[i].answer_type == "text" ? true : false
                    }

                    this.feedbacks = res.data.teacher_feedbacks
                }
                else this.feedbacks = [];

                if(res.data && res.data.tags && res.data.tags.length){
                    let tag_values = [];
                    res.data.tags.forEach(function(entry) {
                        tag_values.push(entry.id); 
                    });

                    this.tag_values = tag_values
                }


            })
            .catch(err => {
                if(err.response.status === 404) {
                    this.module_not_found = true
                    return
                }
            })

        this.$store.dispatch("moduleManagement/getAllTags")
            .then(res => { 
                this.tags = res.data
                this.storeTagId(res.data)
            })
            .catch(err => {
                
            })

        if(!moduleClubManagement.isRegistered) {
            this.$store.registerModule('clubManagement', moduleClubManagement)
            moduleClubManagement.isRegistered = true
        }

        // this.getFeedbackData()
    },

}
</script>

